import * as sapper from '@sapper/app';
import * as Sentry from '@sentry/svelte';

if (process.browser) {
  // Initialize the Sentry SDK here
  Sentry.init({
    dsn: 'https://8b902aa3e8fd448095b44296bd1519f6@o4505027344007168.ingest.sentry.io/4505027348004864',
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    environment: process.env.NODE_ENV,
    release: process.env.SENTRY_RELEASE || 'uniform-hero-client@0.0.1',
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 1.0,
    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  });
}

sapper.start({
  target: document.body,
});
// .then(() => {
//     setTimeout(sapper.prefetchRoutes(), 2000);
// });;
// TODO - list all the routes we might want to prefetch?
